import { z } from "zod";

export const LegalDocumentKind = {
	PRIVACY: "privacy",
	TERMS_OF_USE: "terms_of_use",
} as const;
export type LegalDocumentKindValue = (typeof LegalDocumentKind)[keyof typeof LegalDocumentKind];

export const LegalJurisdiction = {
	US: "US",
	EU: "EU",
	UK: "UK",
	LATAM: "LATAM",
	GLOBAL: "GLOBAL",
} as const;
export type LegalJurisdictionValue = (typeof LegalJurisdiction)[keyof typeof LegalJurisdiction];

export const PersonalDataCategory = {
	EMAIL: "email",
	NAME: "name",
	PHONE: "phone",
	LOCATION: "location",
	PHOTOS: "photos",
	DEVICE_INFO: "device_info",
	USAGE_DATA: "usage_data",
	PROFESSIONAL_INFO: "professional_info",
} as const;
export type PersonalDataCategoryValue = (typeof PersonalDataCategory)[keyof typeof PersonalDataCategory];

export const legalAiWizardSchema = z
	.object({
		kind: z.enum(LegalDocumentKind),
		jurisdiction: z.enum(LegalJurisdiction),
		personal_data_collected: z.array(z.enum(PersonalDataCategory)).min(1),
		uses_analytics: z.boolean(),
		analytics_providers: z.array(z.string().trim().min(1)).max(10),
		uses_cookies: z.boolean(),
		third_party_sharing: z.array(z.string().trim().min(1)).max(20),
		minors_allowed: z.boolean(),
		effective_date: z.iso.date(),
	})
	.strict();

export type LegalAiWizardInput = z.infer<typeof legalAiWizardSchema>;

export const legalAiWizardResponseSchema = z
	.object({
		markdown: z.string(),
	})
	.strict();

export type LegalAiWizardResponse = z.infer<typeof legalAiWizardResponseSchema>;
